<template>
	<AppDialog disableMaxWidth :dialogName="'CommandBarShortcut'" width="960" max-width="90vh"
		><div class="dialog-content width-100 flex-column flex-centerize">
			<div class="title-text mb-2">Set a keyboard shortcut for Ply’s command bar</div>
			<div class="description-text mb-8">The command bar lets you use your tools in any Chrome tab</div>
			<div class="gif-container">
				<img :src="editShortcutGifSrc" class="width-100 height-100" />
			</div>
			<AnemicButton :loading="isLoading" @click="openChromeShortcuts" class="submit-button mt-7"> Open Chrome shortcuts </AnemicButton>
			<iframe
				@load="close"
				class="extension-frame"
				v-if="showExtensionIframe"
				:src="`chrome-extension://${plyExtensionId}/app/app.html#/manage-extension-shortcuts`"
			/>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
const EDIT_SHORTCUT_GIF_SRC = `/assets/gif/update-command-bar-shortcut.gif`;
export default {
	name: 'EditCommandBarShortcutDialog',
	components: {
		AppDialog,
	},
	props: {
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		plyExtensionId() {
			return process.env.VUE_APP_CHROME_EXTENSION_ID;
		},
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		openChromeShortcuts() {
			this.isLoading = true;
			this.showExtensionIframe = true;
		},
	},
	data() {
		return {
			isLoading: false,
			showExtensionIframe: false,
			editShortcutGifSrc: EDIT_SHORTCUT_GIF_SRC,
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	width: 960px;
	height: 754px;
	max-width: 90vh;
	max-height: 90vh;
	border-radius: 10px;
	background: var(--white);
	padding: 35px 65px 23px 65px;
	box-shadow: 0px 3px 6px #00000029;
}

.title-text {
	font-size: 20px;
	font-weight: bold;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 12px;
	color: var(--primary-font-color);
}

.submit-button {
	width: 215px !important;
	height: 45px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	text-transform: none !important;
	background: #5858ec !important;
}
.gif-container {
	width: 100%;
	overflow: hidden;
	border-radius: 10px;
	background: var(--white);
	border: 1px solid #d6ddea;
}
.extension-frame {
	width: 0px;
	height: 0px;
	overflow: hidden;
}
</style>
